export enum TRACES {
  CHAT_LOAD = 'Chat Load',
}
